/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_Fact_2Inputs */

const en_mk_hero_fact_2 = /** @type {(inputs: Mk_Hero_Fact_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud or your computer`)
};

const id_mk_hero_fact_2 = /** @type {(inputs: Mk_Hero_Fact_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud atau komputer sendiri`)
};

/**
* | output |
* | --- |
* | "Cloud or your computer" |
*
* @param {Mk_Hero_Fact_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_fact_2 = /** @type {((inputs?: Mk_Hero_Fact_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_Fact_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_fact_2(inputs)
	return en_mk_hero_fact_2(inputs)
});